var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cont-lineage-iframe" },
    [
      _c("h5", { staticClass: "title-section" }, [_vm._v("Display File")]),
      _c("article", { staticClass: "cont-iframe", attrs: { id: "SECTION" } }),
      _c(
        "b-card",
        [
          _c("loading", {
            attrs: {
              active: _vm.isLoading,
              "can-cancel": true,
              "is-full-page": false,
            },
            on: {
              "update:active": function ($event) {
                _vm.isLoading = $event
              },
            },
          }),
          _c("b-row"),
          _vm.image != null
            ? _c(
                "b-col",
                { staticClass: "preview-image", attrs: { sm: "12" } },
                [
                  _vm.contentType.indexOf("image") > -1
                    ? _c("div", [_c("img", { attrs: { src: _vm.image } })])
                    : _c("div", [
                        _c("div", { staticClass: "file" }, [
                          _c("span", [_vm._v(_vm._s(_vm.filename))]),
                        ]),
                      ]),
                  _c("div", { staticClass: "mt-3" }, [
                    _c(
                      "a",
                      {
                        staticClass: "download-btn",
                        attrs: { href: _vm.image, download: _vm.filename },
                      },
                      [_vm._v("Download")]
                    ),
                  ]),
                ]
              )
            : _c(
                "b-col",
                { staticClass: "preview-image", attrs: { sm: "12" } },
                [_c("div", { staticClass: "auxiliar" })]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }